import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { useAuthStore } from '@/entities/user';
import { myQuoteDetailPath } from '@/shared/config';
import { buttonVariants, cn } from '@/shared/ui';

const LINK_CLASS = cn(
  buttonVariants({ variant: 'outline', size: 'lg' }),
  'h-12 border-foreground/20 px-8',
);

export interface GuestQuoteClaimedProps {
  readonly quoteRequestId: string;
}

/**
 * 연결됨(결정 G9) — 회원 계정에 연결된 견적은 링크로 내용을 보여 주지 않는다. 화면은 누가 연결했는지 모른다.
 * 로그인했으면 내 견적 상세 링크를 준다. 연결한 회원이면 열리고, 아니면 그 화면이 찾을 수 없음으로 답한다.
 * 로그인 전이면 로그인한 뒤 내 견적 상세로 돌아오는 로그인 링크를 준다.
 */
export const GuestQuoteClaimed = ({ quoteRequestId }: GuestQuoteClaimedProps): ReactElement => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const detailPath = myQuoteDetailPath(quoteRequestId);

  return (
    <section className="flex flex-col items-center gap-6 border-y border-foreground/10 py-24 text-center">
      <div className="flex flex-col gap-3">
        <h1 className="text-2xl font-bold tracking-[-0.02em] sm:text-3xl">
          회원 계정에 연결된 견적이에요
        </h1>
        <p className="text-sm text-muted-foreground">
          연결한 계정으로 로그인하면 내 견적에서 확인하고 주문할 수 있어요.
        </p>
      </div>
      {isAuthenticated ? (
        <Link to={detailPath} className={LINK_CLASS}>
          내 견적에서 보기
        </Link>
      ) : (
        <Link to="/sign-in" state={{ from: detailPath }} className={LINK_CLASS}>
          로그인
        </Link>
      )}
    </section>
  );
};
